/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.listeditor')
    .component('listeditor', {
      restrict: 'E',
      bindings: {
        list: '<',
        parentsave: '&'
      },
      //templateUrl: 'vcutils/listeditor/listeditorform-component.tpl.html',
      template: `
        <div ng-repeat="a in vm.tmplist track by $index" ng-show="vm.tmplist.length > 0">
          <div class="input-group">
            <input type="text" class="form-control" ng-model="a" placeholder="Bestehendes ersetzen...">
              <span class="input-group-btn">
                <button class="btn btn-danger" type="button" ng-click="vm.splice($index)"><i class="fa fa-remove"></i></button>
              </span>
          </div>
        </div>
        <form name="vm.formid" >
        <div class="input-group">
          <input type="text" class="form-control" ng-model="vm.newvalue" 
            placeholder="Neuer Wert..." ng-keyup="$event.keyCode == 13 && vm.add()">
              <span class="input-group-btn">
                <button class="btn btn-success" type="button" ng-click="vm.add()"><i class="fa fa-plus"></i></button>
              </span>
        </div>
        </form>      
      
      `,
      controllerAs: 'vm',
      controller: ['$log',
      function ($log) {
        let vm = this;
        vm.save = save;
        vm.splice = splice;
        vm.add = add;
        vm.formid = guid;
        vm.$onInit = function () {
          vm.lastlist = angular.copy(vm.list);
          vm.tmplist = angular.copy(vm.list);
        };

        vm.$onChanges = function (changes) {
          if (changes.list) {
            if (!changes.list.isFirstChange()) {
              vm.lastlist = angular.copy(vm.list);
              vm.tmplist = angular.copy(vm.list);
            }
          }
        };

        function save() {
          if (!angular.equals(vm.tmplist, vm.lastlist)) {
            vm.lastlist = angular.copy(vm.tmplist);
            vm.parentsave({list: vm.tmplist});
          }
        }

/*        function cancel() {
          vm.tmplist = angular.copy(vm.lastlist);
          vm.oncancel();
        }*/

        function splice(i) {
          vm.tmplist.splice(i, 1);
          $log.debug('array: ', vm.tmplist);
          save();
        }

        function add() {
          if (!angular.isArray(vm.tmplist)) {
            vm.tmplist = [];
          }
          vm.tmplist.push(vm.newvalue);
          $log.debug('array: ', vm.tmplist);
          vm.newvalue = '';
          save();
        }

        function guid() {
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
              .toString(16)
              .substring(1);
          }
          return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
        }

      }] // controller
    }); // component

// klammerfriedhof
}());